import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ComposedAL } from 'components/common/charts/charts';
import { Loading } from 'components/common/Elements/Elements';

import { getRequest } from 'utils/requests';
import { createConfig } from 'components/common/charts/ComposedAL/helpers/helpers';

const Chart = ({ customerId, chartColor }) => {
  const [ticketsCharts, setTicketsCharts] = useState([]);
  const [loaderChart, setLoaderChart] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getRequest('/customer/satisfaction/tickets/chart')
      .then(res => {
        if (!cancelled) {
          setTicketsCharts(res.body);
          setLoaderChart(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoaderChart(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  const trendKey = 'totalTicketsCount';
  const notAreaArr = ['date', trendKey]; //not area keys

  const config = {
    title: 'Tickets Number Over Time',
    trendKey: trendKey,
    config: createConfig(ticketsCharts, notAreaArr, loaderChart, chartColor)
  };

  if (loaderChart) {
    return <Loading />;
  }

  return <ComposedAL config={config} data={ticketsCharts} />;
};

Chart.propTypes = {
  customerId: PropTypes.string,
  chartColor: PropTypes.object
};

export default Chart;
